import { Lightbox, LightboxType } from './modules/lightbox';
import { UrlParser } from './modules/url';
export class Site {
    constructor() {
        this.bind();
    }
    bind() {
        const vimeo = document.body.querySelectorAll("a[href*='vimeo.com']");
        if (vimeo.length > 0) {
            vimeo.forEach(link => {
                link.addEventListener('click', (ev) => {
                    var _a, _b, _c, _d;
                    ev.preventDefault();
                    const href = link.getAttribute("href");
                    const url = new UrlParser(href);
                    const width = parseInt((_b = (_a = url.GetParam("width")) === null || _a === void 0 ? void 0 : _a.Value) !== null && _b !== void 0 ? _b : "940", 10);
                    const height = parseInt((_d = (_c = url.GetParam("height")) === null || _c === void 0 ? void 0 : _c.Value) !== null && _d !== void 0 ? _d : "528", 10);
                    const embedUrl = "/Blocks/Embed?" + Object.param({ url: href, width: width, height: height });
                    const lightbox = new Lightbox({ disableScrollOnOpen: false, width: width, height: height, type: LightboxType.AJAX, href: embedUrl });
                    lightbox.open();
                });
            });
        }
        const pdf = document.body.querySelectorAll("a[href*='.pdf']");
        if (pdf.length > 0) {
            pdf.forEach(link => {
                link.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    const href = link.getAttribute("href");
                    const formUrl = "/umbraco/spinchem/forms/download?" + Object.param({ file: href, currentPage: window["Site"]["CurrentPageId"] });
                    const lightbox = new Lightbox({ disableScrollOnOpen: false, width: 400, type: LightboxType.AJAX, href: formUrl });
                    lightbox.open();
                });
            });
        }
        const presentation = document.body.querySelectorAll("a.presentation");
        if (presentation.length > 0) {
            presentation.forEach(link => {
                link.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    let href = link.getAttribute("href");
                    if (href.indexOf("?") > -1)
                        href += "&embed=true";
                    else
                        href += "?embed=true";
                    const lightbox = new Lightbox({
                        disableScrollOnOpen: true,
                        width: 1200,
                        allowFullscreen: true,
                        type: LightboxType.AJAX,
                        href: href
                    });
                    lightbox.open();
                });
            });
        }
        var productFeatures = document.querySelectorAll(".product-features");
        if (productFeatures.length > 0) {
            productFeatures.forEach(productFeature => {
                var featureImages = productFeature.querySelectorAll(".feature-image");
                var features = productFeature.querySelectorAll(".feature");
                if (features.length > 0) {
                    var key = features.item(0).getAttribute("data-feature");
                    featureImages.forEach(featureImage => {
                        if (featureImage.classList.contains(key)) {
                            featureImage.style.display = "block";
                        }
                        else {
                            featureImage.style.display = "none";
                        }
                    });
                }
                features.forEach(feature => {
                    feature.addEventListener("mouseover", (event) => {
                        var key = feature.getAttribute("data-feature");
                        featureImages.forEach(featureImage => {
                            if (featureImage.classList.contains(key)) {
                                featureImage.style.display = "block";
                            }
                            else {
                                featureImage.style.display = "none";
                            }
                        });
                    });
                });
            });
        }
    }
}
